import { render, staticRenderFns } from "./itemsInvesstorList.vue?vue&type=template&id=2facead2&scoped=true&"
import script from "./itemsInvesstorList.vue?vue&type=script&lang=js&"
export * from "./itemsInvesstorList.vue?vue&type=script&lang=js&"
import style0 from "./itemsInvesstorList.vue?vue&type=style&index=0&id=2facead2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2facead2",
  null
  
)

export default component.exports